module.exports = require("scratch-svg-renderer");